/* eslint-disable no-underscore-dangle */
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { PopoverController } from '@ionic/angular';
import {
	ICalendarEvent,
	NgAddToCalendarService,
} from '@trademe/ng-add-to-calendar';
import firebase from 'firebase/compat/app';
import { LearningService } from 'src/app/pages/app/learning/service/learning.service';
import { RudderStack } from 'src/app/services';
@Component({
	selector: 'app-rating-modal',
	templateUrl: './rating-modal.component.html',
	styleUrls: ['./rating-modal.component.scss'],
})
export class RatingModalComponent implements OnInit {
	rating: any[];
	shared = false;
	rate: 0;
	title = 'How did you like it?';
	@Input() type: 'rating' | 'cal';
	@Input() eventData;
	@Input() cohortId;
	constructor(
		private popoverController: PopoverController,
		private _addToCalendarService: NgAddToCalendarService,
		private _sanitizer: DomSanitizer,
		private learningService: LearningService,
		private rudderStack: RudderStack,
	) {}

	ngOnInit() {
		if (this.eventData.type === "class") {
			this.rudderStack.log({
				type: 'feedback_class_click',
				cohortId: this.cohortId,
				classId: this.eventData.classId,
			});
		} else if (this.eventData.type === 'assignments') {
			this.rudderStack.log({
				type: 'feedback_assignment_click',
				cohortId: this.cohortId,
				assignmentId: this.eventData.id,
			});
		} else {
			this.rudderStack.log({
				type: 'feedback_event_click',
				cohortId: this.cohortId,
				eventId: this.eventData.eventId,
			});
		}
		this.rating = [false, false, false, false, false];
	}

	onClose() {
		this.popoverController.dismiss();
	}

	onStarClick(index) {
		this.rate = index + 1;
		for (let i = 0; i < 5; i++) {
			this.rating[i] = index >= i ? true : false;
		}
		//return;
		let id = this.eventData.eventId;
		if (this.eventData.type === 'assignments') {
			id = this.eventData.id;
		}
		if (this.eventData.type === "class") {
			this.rudderStack.log({
				type: 'feedback_class_submit',
				cohortId: this.cohortId,
				classId: this.eventData.classId,
				score: this.rate
			});
		}
		else if (this.eventData.type === "assignments") {
			this.rudderStack.log({
				type: 'feedback_assignment_submit',
				cohortId: this.cohortId,
				assignmentId: this.eventData.id,
				name: this.eventData.name,
			});
		}
		else {
			this.rudderStack.log({
				type: 'feedback_event_submit',
				cohortId: this.cohortId,
				eventId: this.eventData.eventId,
				name: this.eventData.name,
				score: this.rate
			});
		}
		this.learningService
			.rateAssignment(
				this.cohortId,
				this.eventData.eventId,
				this.eventData.type,
				firebase.auth().currentUser?.email,
				this.rate,
				'',
			)
			.subscribe((data: any) => {
				if (data.message?.includes('success')) {
					this.shared = true;
					this.title = 'Thanks for sharing!';
				}
			});

		// setTimeout(() => {
		// 	this.shared = true;
		// 	this.title = 'Thanks for sharing!';
		// }, 500);
	}
	async closePopOver() {
		await this.popoverController.dismiss();
	}

	onCal(str) {
		const newEvent: ICalendarEvent = {
			// Event title
			title: this.eventData.name,
			// Event start date
			start: new Date(this.eventData.startDateTime),
			// Event duration (IN MINUTES)
			duration: 120,
			// If an end time is set, this will take precedence over duration (optional)
			end: new Date(this.eventData.endDateTime),
			// Event Description (optional)
			description: this.eventData.description,
		};
		let getHrefFor;
		if (str === 'apple') {
			getHrefFor = this._addToCalendarService.calendarType.iCalendar;
		}
		if (str === 'google') {
			getHrefFor = this._addToCalendarService.calendarType.google;
		}

		const URL = this._addToCalendarService.getHrefFor(getHrefFor, newEvent);
		const sanitizeUrl: any = this._sanitizer.bypassSecurityTrustUrl(URL);

		window.open(sanitizeUrl.changingThisBreaksApplicationSecurity, '_blank');
	}

	shareMore() {
		const type = this.eventData.type;
		let url = ``;

		if (type === 'class') {
			url = `https://atisundar.typeform.com/class-feedback#class=${this.eventData.eventId}&cohort=${this.cohortId}`;
		} else if (type === 'webinar') {
			url = `https://atisundar.typeform.com/events-feedback#event_id=${this.eventData.eventId}&cohort=${this.cohortId}`;
		} else if (type === 'assignments') {
			url = `https://atisundar.typeform.com/assignment#assignment_id=${this.eventData.id}&cohort=${this.cohortId}`;
		}

		window.open(url, '_blank');
	}
}
